import { IAction, ITableAction } from '@/pages/intelligence/pages/GlobalView/components/TopMarketGenreCore/types';
import { getSource, getSourceUpdatedGamesDataSource } from '@/pages/intelligence/services/sourceMetrics';
import React, { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { Bubble, Justify, Layout, SearchBox, Table } from 'tea-component';
import SourceTable from '../Table';
import { getLocale, useIntl } from 'umi';
const { Body, Content } = Layout;

import Filter from '../Filter/OpinionFilter'

import TextMore from '../TextMore';
import ChannelLabel from '../ChannelLabel';

import { dbiPageLogMes } from "@/pages/intelligence/utils/buriedPointCfg"
import { buriedPointPage, buriedPointSearch } from "@/pages/home/utils/buriedPoint";
import { filterSourcesRecordsBySearch } from '../../../searchUtils';

const pageLogMes = dbiPageLogMes.sourcesMetricsSourcesOpinionsSources;
export const gameTypeCN = (value: string) => {
  const typeArray = value.toLowerCase().split('/')
  for (let i = 0; i < typeArray.length; i++) {
    switch (typeArray[i]) {
      case 'mobile':
      case 'mobile game':
        typeArray[i] = '手游'
        break
      case 'pc':
      case 'pc game':
        typeArray[i] = '端游'
        break
      case 'console':
      case 'console game':
        typeArray[i] = '主机游戏'
        break
    }
  }
  return typeArray.join('/')
}

export default function OpinionsSources() {
  const [loading, setLoading] = useState(true)
  const [isError, setIsError] = useState(false)

  const [dataCN, setDataCN] = useState([])
  const [dataEN, setDataEN] = useState([])

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const debounce = useRef({ interval: 0, delay: 500 }).current;

  const [searchValue, setSearchValue] = useState('')
  const [searchShow, setSearchShow] = useState(false)

  const [showCN, setShowCN] = useState([])
  const [showEN, setShowEN] = useState([])
  const [pageIndex, setPageIndex] = useState(1);
  const tmpCNRef = useRef()
  const tmpENRef = useRef()
  const getData = (params?: any) => {
    setLoading(true)

    const param = {
      tab: "opinions",
      get_games_total: false,
      ...params
    }

    getSource(param)
      .then(async (data) => {
        setDataCN([])
        setDataEN([])

        data?.forEach((item) => {
          const tmp = item.list.map((item, idx) => {
            return {
              ...item,
              id: idx + 1
            }
          }) || [];

          if (item.language === 'cn') {
            tmpCNRef.current = tmp
            setDataCN(tmp)
          } else {
            tmpENRef.current = tmp
            setDataEN(tmp)
          }
        });
        // 获取完第一个接口数据后，再次请求第二个接口获取Monthly updated games，Data Source这两列数据
        const res = await getSourceUpdatedGamesDataSource()
        const newDataSource = (dataSource) => (dataSource.map((item) => {
          for (let i = 0; i < res.length; i++) {
            if (res[i]?.source_name?.toLowerCase() === item?.data_source?.toLowerCase()) {
              return { ...item, total_comments: res[i].total_comments, total_games: res[i].total_games }
            }
          }
          return item
        }))
        setDataCN(newDataSource(tmpCNRef.current))
        setDataEN(newDataSource(tmpENRef.current))
      })
      .catch((err) => {
        console.log(err)
        setIsError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const data = useMemo(() => { return locale == 'zh-CN' && dataCN.length > 0 ? dataCN : dataEN }, [locale, dataCN, dataEN])

  // console.log("DA", data)

  const columns = [
    {
      key: 'id',
      fixed: 'left',
      align: 'left',
      width: 65,
      header: "#",
    },
    {
      key: 'data_source',
      fixed: 'left',
      align: 'left',
      width: 180,
      header: formatMessage({ id: 'dbi-sm-filter-datasource' }),
      render: (record: any) => {
        return (
          <ChannelLabel
            channel_name={record.data_source.toLowerCase()}
            replaceText={record.data_source}
          />
        );
      },
    },
    {
      key: 'total_games',
      align: 'right',
      width: 130,
      header: formatMessage({ id: 'dbi-sm-filter-datasource' }),
      render: (cvm) => {
        let show = '-'
        if (cvm.total_games) {
          if (cvm.total_games > 800) show = '800+'
          else show = cvm.total_games
        }
        return show
      }
    },
    {
      key: 'total_comments',
      align: 'right',
      width: 205,
      header: formatMessage({ id: 'dbi-sm-table-comment' }),
      render: (cvm) => { return cvm?.total_comments ? cvm?.total_comments : '-' }
    },
    {
      key: 'feature',
      align: 'left',
      width: 330,
      header: formatMessage({ id: 'dbi-sm-table-feature' }),
      render: (cvm) => {
        return (
          <div style={{ maxHeight: '57px', whiteSpace: 'pre-wrap' }}>
            {cvm.feature ? cvm.feature : '-'}
          </div>
        )
      }
    },
    {
      key: 'game_type',
      align: 'left',
      width: 230,
      header: formatMessage({ id: 'dbi-sm-filter-gametype' }),
      render: (cvm) => { return cvm?.game_type ? (locale == 'zh-CN' ? gameTypeCN(cvm?.game_type) : cvm?.game_type) : '-' } // 后端接口没有返回中文，定义方法进行翻译
    },
    {
      key: 'metric',
      align: 'left',
      width: 400,
      header: formatMessage({ id: 'dbi-sm-table-engagement' }),
      render: (cvm) => {
        return cvm?.metric ? <TextMore data={cvm?.metric.replace(/(\r\n|\n|\r)/gm, "<br/>")} title={formatMessage({ id: 'dbi-sm-table-engagement' })} /> : '-'
      }
    },
    {
      key: 'available',
      align: 'left',
      width: 100,
      header: formatMessage({ id: 'dbi-sm-table-availability' }),
      render: (cvm) => { return cvm?.available ? cvm?.available : '-' }
    },
    {
      key: 'url',
      align: 'left',
      width: 300,
      header: formatMessage({ id: 'dbi-sm-table-sourceurl' }),
      render: (cvm) => { return cvm?.url ? cvm?.url : '-' }
    },
  ]

  useEffect(() => {
    getData();
    buriedPointPage(pageLogMes);
  }, [])

  const handleConfirm = async (value: any) => {
    // console.log("CONFIRM", value)
    getData(value)
    setSearchValue('')
    setSearchShow(false)
    setPageIndex(1);
  }

  const handleReset = () => {
    // console.log("RESET")
    setSearchValue('')
    setSearchShow(false)
  };

  /**
   * @description: 设置debounce，避免搜索频繁更改Report列表
   * @param {string} word 搜索关键字
   * @return {*}
   */
  const debounceSearchChange = (word: string) => {
    clearTimeout(debounce.interval);
    //@ts-ignore
    debounce.interval = setTimeout(() => {
      handleSearch(word);
      if (pageLogMes?.pageId) {
        buriedPointSearch(
          { extInfo: pageLogMes?.pageId, typeId: pageLogMes?.typeId },
          word,
        );
      }
    }, debounce.delay);
  }

  const handleSearch = (word: string) => {
    if (word == '') {
      setSearchShow(false);
    } else {
      const showEN = filterSourcesRecordsBySearch(dataEN, word);
      const showCN = filterSourcesRecordsBySearch(dataCN, word);
      setShowCN(showCN);
      setShowEN(showEN);
      setSearchShow(true);
      setPageIndex(1);
    }
  }

  const show = useMemo(() => { return locale == 'zh-CN' && showCN.length > 0 ? showCN : showEN }, [locale, showCN, showEN])


  return (
    <>
      <Filter
        filterConfirm={handleConfirm}
        filterReset={handleReset}
      />
      <Justify
        className="dbi-imurreports-justify"
        style={{ marginTop: '20px' }}
        right={
          <SearchBox
            className="edit-search-box"
            placeholder={formatMessage({ id: 'dbi_search_for_source' })}
            value={searchValue}
            onSearch={() => {
              // debounceSearchChange() 
            }}
            onChange={(word) => {
              setSearchValue(word);
              if (word == '') {
                setSearchShow(false);
              } else if (word.replace(/^\s*/g, '')) {
                debounceSearchChange(word);
              }
            }}
            onClear={() => { setSearchShow(false) }}
          />
        }
      />
      <SourceTable
        records={searchShow ? show : data}
        columns={columns}
        loading={loading}
        error={isError}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
      />
    </>
  )
};
